var defaultItems = function () {
    return {
        "Products": [],
        "ProductsCount": 0,
        "Groups": [],
        "GroupsCount": 0,
        "Blogs": [],
        "BlogCount": 0
    };
};

let mainSearchState = null;
let resetMainSearch = null;

let controller, signal, timer;

class Search extends React.Component {
    componentDidMount() {
        this.setState({
            keyword: "",
            searching: false,
            items: defaultItems(),
            amountOfSearchsymbols: 0,
        });

        mainSearchState = this;
        resetMainSearch = function(){
            document.querySelector("#searchInput").value = "";
            document.querySelector(".search-actions input").value = "";
            mainSearchState.setState({ keyword: "", searching: false, items: defaultItems() })
            document.querySelector("#top-subnav-search").style.height = "0px";
            document.querySelector("#top-subnav-search").classList.remove("not-empty");
            document.querySelector(".search-actions").classList.remove("active");
        }
        document.querySelector(".search-actions .icon-close").onclick = this.resetSearch;
        document.querySelector("#top-search-background").onclick = this.resetSearch;
        document.querySelector(".search-actions input").addEventListener("keyup",this.handleChange);

    }

    handleChange(e) {
        //let main = this;
        //e.persist();
        if(e.key == "Escape")
        {
            resetMainSearch();
            return false;
        }

        clearTimeout(timer);

        timer = setTimeout(() => {
            mainSearchState.setState({ amountOfSearchsymbols: e.target.value.length });
            mainSearchState.setState({ searching: true });
    
            if (e.target.value.length > 2) {
                if (controller) 
                {
                    controller.abort();
                }
                controller = new AbortController();
                signal = controller.signal;
    
                fetch('/Umbraco/Api/SearchApi/Search?term=' + e.target.value + '&root=' + searchLang.root + '&lang=' + searchLang.lang + "&url=" + searchLang.products_url, {
                    method: 'get',
                    signal: signal,
                }).then(function (response) {
                    return response.json();
                }).then(function (data) {
                    mainSearchState.setState({ keyword: e.target.value, searching: false, items: data })
                    let height = document.querySelector(".search-results .col-left").clientHeight;
                    if (document.querySelector(".search-results .col-right").clientHeight > height) {
                        height = document.querySelector(".search-results .col-right").clientHeight;
                    }
                    document.querySelector("#top-subnav-search").style.height = (height + 70) + "px";
                    document.querySelector("#top-subnav-search").classList.add("not-empty");
                    document.querySelector(".search-actions").classList.add("active");
                }).catch(function (err) {
                    // Error :(
                });
            } else {
                mainSearchState.setState({ keyword: e.target.value, searching: false, items: defaultItems() })
                document.querySelector("#top-subnav-search").style.height = "0px";
                document.querySelector("#top-subnav-search").classList.remove("not-empty");
                document.querySelector(".search-actions ").classList.remove("active");
            }
        }, 300);
    }
    handleEsc(e) {
        if(e.key == "Escape")
        {
            resetMainSearch();
            return true;
        }
        return false;
    }

    resetSearch(e){
            document.querySelector(".search-actions").classList.remove("mobile-active");
            document.querySelector(".topdown-search").classList.remove("mobile-active");
            resetMainSearch();
    }

    showProducts(items, keyword) {
        if (items.Products.length > 0) {
            return (
                <div className="search-result-products">
                    <h3>{searchLang.products}</h3>
                    <ProductList items={items.Products} word={keyword} />
                    <a href={items.AllProductsUrl} style={{ display: items.ProductCount < 5 ? "none" : "" }} className="hd-btn secondary-color"> {searchLang.show} ({items.ProductCount})</a>
                    <button id="search-reset" onClick={this.resetSearch.bind(this)} className="hd-btn secondary-color">{searchLang.clearSearch}</button>
                </div>)
        }
    }

    showCatagories(items, keyword) {
        if (items.Groups.length > 0) {
            return (
                <div className="search-result-categories">
                    <h3>{searchLang.categories}</h3>
                    <GroupList items={items.Groups} word={keyword} />
                    <a href="#" style={{ display: items.GroupCount < 7 ? "none" : "" }} className="hd-btn secondary-color">{searchLang.show} ({items.GroupCount}) <span className="icon-pin"></span></a>
                </div>)
        }
    }

    showBlogs(items, keyword) {
        if (items.Blogs.length > 0) {
            //<a href="#" style={{ display: items.BlogCount < 5 ? "none" : "" }} className="hd-btn secondary-color">{searchLang.show} ({items.BlogCount}) <span className="icon-pin"></span></a>
            return (
                <div className="search-result-from-blog">
                    <h3>{searchLang.blog}</h3>
                    <BlogList items={items.Blogs} word={keyword} />
                </div>)
        }
    }

    renderSearchResults(items, keyword) {
        if (items.ProductCount == 0 && items.BlogCount == 0 && items.GroupCount == 0) {
            if (this.state != null && this.state.amountOfSearchsymbols > 2) {     
                return (                    
                    <div className="megatopdown-row search-results empty">
                       <h3> {searchLang.noSearchResult} </h3>
                    </div>
                );
            }
        }
        else {
            return (
                <div className={items == 0 ? "megatopdown-row search-results inactive" : "megatopdown-row search-results active"}>
                    <div className="col-left">
                        {this.showProducts(items, keyword)}
                    </div>

                    <div className="col-right">
                        {this.showCatagories(items, keyword)}
                        {this.showBlogs(items, keyword)}
                    </div>
                </div>
            );
        }
    }


    render() {
        let keyword = "";
        let searching = false;
        let items = defaultItems();
        if (this.state != null) {
            items = this.state.items;
            keyword = this.state.keyword;
            searching = this.state.searching;
        } else {
        }

        return <div>
            <div className="megatopdown-row">
                <div className="search-col">
                    <input id="searchInput" onChange={this.handleChange.bind(this)} onKeyDown={this.handleEsc.bind(this)} type="text" />
                    {keyword !== "" ? <span onClick={this.resetSearch.bind(this)} className="icon-close"></span> : <span className="icon-search"></span> }
                   {/*<button type="submit" className="hd-btn secondary-color search-button"><span className={!searching ? "icon-pin" : "icon-pin searching"}></span> {searchLang.search}</button>*/} 
                </div>
            </div>
            {this.renderSearchResults(items, keyword)}
        </div>;
    }
}


class ProductList extends React.Component {
    render() {
        let list = this.props.items.map(function (e, index) {
            return <ProductItem key={index} data={e} word={this.props.word} />;
        }, this);

        return <ul className="product-list">{list}</ul>;
    }
}

class ProductItem extends React.Component {

    getDescription(description){
        let desc = description;
        const terms =  this.props.word.toLowerCase().split(' ');

        for (var i = 0; i < terms.length; i++) {
            const term = terms[i];
            const termLength = term.length;
            if (termLength == 0)
                continue;

            // Special case when the search term is a substring of "label"
            // TODO: Handle this in a better way where the actual substring is marked, but label tags are not
            if ("label".indexOf(term) > -1)
                continue;

            let wordmatch = desc.toLowerCase().indexOf(term);
            if (wordmatch != -1) {
                let startPos = 0;
                if(wordmatch - 20 > 0){
                    startPos = (wordmatch - 20);
                }
                let tempdesc = startPos > 0 ? "..." : "";
                tempdesc += "<span>" + desc.substr(startPos, wordmatch - startPos) + "</span>";
                tempdesc += "<strong>" + desc.substr(wordmatch, termLength) + "</strong>";
                tempdesc += desc.substr((wordmatch + termLength), desc.length);
                desc = tempdesc;
            }
        }

        return desc;
    }

    render() {
        let title = this.props.data.Title;
        var alternativeItemNumber = ""
        if (this.props.data.ItemStatus == "Outphased") {
            if (this.props.data.AlternativeItemNumber)
            {
                alternativeItemNumber = searchLang.outphasedReplacement + " " + this.props.data.AlternativeItemNumber;
            }
            else
            {
                alternativeItemNumber = searchLang.outphasedNoReplacement;
            }            
        }
        if (title != null) {
            const terms = this.props.word.toLowerCase().split(' ');

            for (var i = 0; i < terms.length; i++) {
                const term = terms[i];
                const termLength = term.length;
                if (termLength == 0)
                    continue;

                // Special case when the search term is a substring of "label"
                // TODO: Handle this in a better way where the actual substring is marked, but label tags are not
                if ("label".indexOf(term) > -1)
                    continue;

                let wordmatch = title.toLowerCase().indexOf(term);
                if (wordmatch != -1) {
                    let temptitle = "";
                    temptitle += title.substr(0, wordmatch);
                    temptitle += "<label>" + title.substr(wordmatch, termLength) + "</label>";
                    temptitle += title.substr((wordmatch + termLength), title.length);
                    title = temptitle;
                }
            }
        }

        return <li>
            <a href={searchLang.products_url + this.props.data.relativeUrl} class="product-result">
                <div className="image-content">
                    <img src={this.props.data.Image != undefined && this.props.data.Image != "" ? this.props.data.Image : "/images/httpwww.freeiconspng.comimg23480-no-image-icon-23480.jpg"} />
                </div>
                <div className="text-content">

                    <span>{this.props.data.Id}</span>
                    <p style={{ color: "red" }}>{alternativeItemNumber}</p>
                    <h4 dangerouslySetInnerHTML={{ __html: title }} />
                    <p dangerouslySetInnerHTML={{ __html: this.getDescription(this.props.data.Description) }} />
                </div>
            </a>
        </li>;
    }
}

class GroupList extends React.Component {
    render() {
        let list = this.props.items.map(function (e, index) {
            return <GroupItem key={index} data={e} word={this.props.word} />;
        }, this);

        return <div className="group-list">{list}</div>;
    }
}

class GroupItem extends React.Component {
    render() {
        let title = this.props.data.Title;
        if (title != null) {
            let wordmatch = title.toLowerCase().indexOf(this.props.word);
            if (wordmatch != -1) {
                let temptitle = "";
                temptitle += title.substr(0, wordmatch);
                temptitle += "<label>" + title.substr(wordmatch, this.props.word.length) + "</label>";
                temptitle += title.substr((wordmatch + this.props.word.length), title.length);
                title = temptitle;
            }
        }
        return <a href={searchLang.products_url + this.props.data.Url} className="category-result" dangerouslySetInnerHTML={{ __html: title }} />;
    }

}

class BlogList extends React.Component {
    render() {
        let list = this.props.items.map(function (e, index) {
            return <BlogItem key={index} data={e} word={this.props.word} />;
        }, this);

        return <div className="blog-list">{list}</div>;
    }
}

class BlogItem extends React.Component {
    render() {
        let title = this.props.data.Title;
        if (title != null) {
            let wordmatch = title.toLowerCase().indexOf(this.props.word);
            if (wordmatch != -1) {
                let temptitle = "";
                temptitle += title.substr(0, wordmatch);
                temptitle += "<label>" + title.substr(wordmatch, this.props.word.length) + "</label>";
                temptitle += title.substr((wordmatch + this.props.word.length), title.length);
                title = temptitle;
            }
        }
        return <a href={this.props.data.Url} className="blog-result" dangerouslySetInnerHTML={{ __html: title }} />;
    }

}

if(document.getElementById('search-item') != null){ 
    ReactDOM.render(<Search data-height={619} />, document.getElementById('search-item'));
}


